import GenreSubGenreMap from '../../../commons/util/GenreSubGenreMapping.json';

export function getSubGenreList (genreValue) {
    return GenreSubGenreMap[genreValue];
}
